import {useEffect, useState} from 'react';
import {_FILES} from '../../configuration/index.config';
import {request} from '../../services/HttpRequestService';
import utilService from '../../services/utilService';
import {storageService} from '../../services/storageService';
import loadService from '../../services/loadService';
import {has} from 'lodash';
import {filesStatusList, counterOfFiles, FOLDER_TYPE, ERROR_UPLOAD, fileDeleted, PROJECT_ID, IMAGE_STATUS} from './useUploadProcess.constants';
import {IProject} from '../../pages/DataProjects/Config/DataProjects.types';
import {BackendTagField} from '../../configuration/backendFileds/backendFileld.config';
import {useSetTimeout} from '../useSetTimeout/useSetTimeout';
const {VIDEO, IMAGE} = _FILES;
const useUploadProcess = (activeFolderId, projectIdArg, isAutoClassification = false, openModal: null | Function = null, setFolderType: null | Function = null, folderTypeBeforeUpload = 'empty', project:null | IProject = null) => {
    const [uiFileList, setUiFileList] = useState<any>([]);
    const [isFailedFiles, setIsFailedFiles] = useState(false);
    const [processIsDone, setProcessIsDone] = useState(false);
    const [isProcessStarted, setIsProcessStarted] = useState(false);
    const {_setTimeOut} = useSetTimeout();

    const initProjectId = (projectIdNew) => PROJECT_ID.projectId = projectIdNew;

    /**
     * retryAllFiledFiles - when user wants to retry all failed files
     */
    const retryAllFiledFiles = async () => {
        const copyUiFileList = [...uiFileList];
        const filedList:any[] = [];
        const res = await verifyFiles();


        copyUiFileList.forEach((file, index) => {
            if (fileDeleted[file.serverId] || file.status === IMAGE_STATUS.VERIFY_FAILED) {
                changeStatus(index, IMAGE_STATUS.UPLOADING);
                const { WrongFileType, TooLarge} = res.data;

                if (file.name in WrongFileType || file.name in TooLarge) {
                    _setTimeOut(() => {
                        changeStatus(file.client_id, IMAGE_STATUS.VERIFY_FAILED);
                        counterOfFiles.counter += 1;
                    }, 1000);

                } else {
                    filedList.push(file);
                }

            }
        });

        startProcess(filedList);
    };

    /**
     * retryFile - when user wants to retry failed file
     * @param file - file object
     */
    const retryFile = async (file) => {
        const copyUiFileList = [...uiFileList];

        const index = copyUiFileList.findIndex((fileObj) => file.client_id === fileObj.client_id);

        if (index > -1) {
            changeStatus(index, IMAGE_STATUS.UPLOADING);

            try {
                const getSignUrlRes:any = await getSignUrl([file], file.serverId);

                file.url = getSignUrlRes.data[file.name].url;
                const oneChunk = [[file]];

                sendToS3(oneChunk);
            } catch (e) {
                setStatus(IMAGE_STATUS.FAILED, file, IMAGE_STATUS.VERIFY_FAILED, 'UPLOAD');
            }
        }
    };

    /**
     * changeStatusFile - when file status change
     * @param index - index of file in array
     * @param status - new status
     * @param errorKey - error details
     */
    const changeStatus = (index, status, errorKey = '') => {
        const copyUiFileList = [...uiFileList];

        (status === IMAGE_STATUS.FAILED || status === IMAGE_STATUS.VERIFY_FAILED) && (copyUiFileList[index].errorMsg = ERROR_UPLOAD[errorKey]);
        copyUiFileList[index].status = status;
        setUiFileList(copyUiFileList);
    };

    /**
     * closeModal - when user wants to close modal
     * @param setState - if seState from component
     * @param newState - if need to modify newState
     */
    const closeModal = (setState, newState) => {
        loadService.setUploadImages();
        setIsFailedFiles(false);
        setProcessIsDone(false);
        setIsProcessStarted(false);
        setUiFileList([]);
        Object.keys(filesStatusList).forEach((key) => delete filesStatusList[key]);
        Object.keys(fileDeleted).forEach((key) => delete fileDeleted[key]);
        Object.keys(counterOfFiles).forEach((key) => counterOfFiles[key] = 0);
        setState && setState(newState);
    };

    /**
     * setStatus - set server status
     * @param status - file status
     * @param file - file object
     * @param uiStatus - ui status string
     * @param errorKey - error details
     */
    const setStatus = (status, file, uiStatus, errorKey = '') => {
        if (file.serverId) {
            filesStatusList[file.serverId].status = status;
        }
        status === IMAGE_STATUS.SUCCESS && (counterOfFiles.counter += 1);
        status === IMAGE_STATUS.FAILED && (counterOfFiles.counterFail += 1);
        changeStatus(file.client_id, uiStatus, errorKey);
        counterOfFiles.numberOfFiles === (counterOfFiles.counter + counterOfFiles.counterFail) && setProcessIsDone(true);
    };

    /**
     * sendVideoToServer - brake to first frame in server
     * @param file - file object
     */
    const sendVideoToServer = async (file) => {
        const fileData = {
            data_project_id: PROJECT_ID.projectId,
            file_id: file.serverId
        };

        // @ts-ignore
        !isAutoClassification && (fileData.folder_id = activeFolderId);

        try {
            await request.post(storageService.loadFromStorage('token'), 'UPDATE_VIDEO', fileData);
            setStatus(IMAGE_STATUS.SUCCESS, file, IMAGE_STATUS.DONE);
        } catch (e) {
            file.status !== IMAGE_STATUS.CANCEL && setStatus(IMAGE_STATUS.FAILED, file, IMAGE_STATUS.FAILED, 'UPLOAD');
        }
    };

    /**
     * sendFileToS3 - send video or image to s3
     * @param s3Req - the promise from s3 request
     * @param file - file object
     */
    const sendFileToS3 = async (s3Req, file) => new Promise((resolve) => {
        s3Req.then(() => {
            if (file && file.status !== IMAGE_STATUS.CANCEL) {
                FOLDER_TYPE.type === 'video' ? sendVideoToServer(file) : setStatus(IMAGE_STATUS.SUCCESS, file, IMAGE_STATUS.DONE);
            }
            resolve(1);
        })
            .catch(() => {
                file.status !== IMAGE_STATUS.CANCEL && setStatus(IMAGE_STATUS.FAILED, file, IMAGE_STATUS.FAILED, 'UPLOAD');
                resolve(1);
            });
    });

    /**
     * onDeleteFile - when user wants to delete file (from upload process)
     * @param file - file object
     * @param setState - if seState from component
     * @param newState - if need to modify newState
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onDeleteFile = async (file, setState = (_) => {}, newState = {}) => {
        if (counterOfFiles.numberOfFiles > 0) {
            const copyUiFileList = [...uiFileList];

            if (counterOfFiles.counter === counterOfFiles.numberOfFiles && !fileDeleted[file.serverId]) {
                const fileIndex = copyUiFileList.findIndex((f) => f.serverId === file.serverId);

                if (fileIndex > -1) {
                    filesStatusList[file.serverId].status = IMAGE_STATUS.CANCEL;
                    counterOfFiles.counter -= 1;
                    counterOfFiles.numberOfFiles -= 1;
                    copyUiFileList.splice(fileIndex, 1);
                    setUiFileList(copyUiFileList);
                }

            } else if (!fileDeleted[file.serverId]) {
                const fileIndex = copyUiFileList.findIndex((f) => f.client_id === file.client_id);

                filesStatusList[file.serverId].status = IMAGE_STATUS.CANCEL;
                counterOfFiles.counter -= 1;
                counterOfFiles.numberOfFiles -= 1;
                fileDeleted[file.serverId] = file.serverId;
                fileIndex > -1 && copyUiFileList.splice(fileIndex, 1);
                setUiFileList(copyUiFileList);
            }
        }

    };

    /**
     * onDoneProcess - when user press done or cancel
     * @param doneType - done or cancel
     * @param setState - if seState from component
     * @param newState - if need to modify newState
     * @param tag - {tag_name: ..., tag_id?: ...}
     */
    // eslint-disable-next-line complexity
    const onDoneProcess = async (doneType, setState, newState, tag:any = {}, isSendReq = true, data_project_id = -1) => {

        if (Object.values(tag).length > 0) {
            const copyUiFileList = [...uiFileList];

            copyUiFileList.forEach((f) => {
                filesStatusList[f.serverId].tag = tag;
            });
        }

        const copyFilesStatusList = JSON.parse(JSON.stringify(filesStatusList));

        try {
            const postSignedData = {
                data_project_id: data_project_id > -1 ? data_project_id : PROJECT_ID.projectId,
                files_dict: copyFilesStatusList
            };

            if (Object.keys(copyFilesStatusList).length === 0 && tag) {
                postSignedData['tag_name'] = tag.tag_name;
                postSignedData['tag_id'] = tag.tag_id;
            }
            // @ts-ignore
            !isAutoClassification && (postSignedData.folder_id = activeFolderId);
            const res = isSendReq ? await request.post(storageService.loadFromStorage('token'), 'UPDATE_FILE_STATUS', postSignedData) : null;

            if (Object.values(tag).length > 0) {
                const copyUiFileList = JSON.parse(JSON.stringify(uiFileList));
                const classIndex = newState.classes.findIndex((classObj) => (classObj[BackendTagField.id] ? classObj[BackendTagField.id] === tag[BackendTagField.id] : classObj[BackendTagField.name] === tag[BackendTagField.name]));
                const tagsIndex = newState.tags.findIndex((t) => t[BackendTagField.id] && t[BackendTagField.id] === tag[BackendTagField.id]);

                if (res && 'tags_dict' in res.data && Object.values(res.data.tags_dict).length > 0) {
                    tag[BackendTagField.id] = res.data.tags_dict[tag[BackendTagField.name]];
                    copyUiFileList.forEach((f) => filesStatusList[f.serverId].tag = tag);
                } else if (!isSendReq) {
                    copyUiFileList.forEach((f) => filesStatusList[f.serverId].tag = tag);
                    newState.filesDict = {...newState.filesDict, ...copyFilesStatusList};
                }

                classIndex > -1 ? newState.classes[classIndex] = {...tag, imageList: copyUiFileList} : newState.classes.push({...tag, imageList: copyUiFileList});
                tagsIndex > -1 ? newState.tags[tagsIndex] = tag : newState.tags.push(tag);


                closeModal(setState, newState);
            } else if (doneType === IMAGE_STATUS.CANCEL || counterOfFiles.counter === 0) {
                closeModal(setState, newState);
            } else if (project && res) {
                // @ts-ignore
                const copyProject = {...project};

                copyProject.folders = res.data.folders;
                copyProject.status = res.data.data_project_status;
                copyProject.last_modify = res.data.data_project_last_modify;
                // @ts-ignore
                setFolderType && setFolderType(FOLDER_TYPE.type);
                closeModal(setState, {...newState, ...{
                    fileOrFolderList: copyProject.folders.files_list,
                    folderTypeGlobal: FOLDER_TYPE.type,
                    project: copyProject,
                    storage: {total: res.data.storage.account_total_storage, usage: res.data.storage.account_storage_usage}}});
            } else {
                return res ? res.data : {};
            }
        } catch (e) {
            closeModal(setState, newState);
        }

    };

    /**
     * verifyFiles - verify files in server
     */
    const verifyFiles = async () => {
        const postSignedData = {
            data_project_id: PROJECT_ID.projectId,
            files: uiFileList
        };

        // @ts-ignore
        !isAutoClassification && (postSignedData.folder_id = activeFolderId);
        try {
            return await request.post(storageService.loadFromStorage('token'), 'VERIFY_FILES', postSignedData);
        } catch (e) {
            uiFileList.forEach((file) => setStatus(IMAGE_STATUS.FAILED, file, IMAGE_STATUS.VERIFY_FAILED, 'VERIFICATION'));

            return e;
        }
    };

    /**
     * getSignUrl - get sign url
     * @param files - the files array
     * @param fileServerId - fileServerId if exist
     */
    const getSignUrl = async (files, fileServerId = null) => {
        const postSignedData = {
            data_project_id: PROJECT_ID.projectId,
            file_type: FOLDER_TYPE.type,
            files: files,
            file_id: fileServerId
        };

        // @ts-ignore
        !isAutoClassification && (postSignedData.folder_id = activeFolderId);

        return await request.post(storageService.loadFromStorage('token'), 'SIGNED_URL', postSignedData);
    };

    /**
     * openSignUl - Promise of request of sign url
     * @param file - file object
     */
    const openSignUl = (file) => new Promise((resolve) => {
        const headers = {
            'Content-Type': 'application/octet-stream',
            'x-amz-acl': 'bucket-owner-full-control'
        };

        resolve({req: request.put(file.url, file.fileData, headers), file});
    });

    /**
     * checkIfAllFilesAreInRightType - check all the files are allowed ending (video or image)
     * @param folderType - type allowed
     */
    const checkIfAllFilesAreInRightType = (folderType) => {
        const notAllowedFilesType:any = [];

        uiFileList.forEach((file:any) => {
            folderType[file.type] === undefined && notAllowedFilesType.push(file);
        });

        return notAllowedFilesType;
    };

    /**
     * findTypeFolder - fund if folder is video or image type
     */
    const findTypeFolder = () => {
        const firstFile:any = uiFileList[0];

        return VIDEO.TYPES[firstFile.type] ? VIDEO.TYPES : IMAGE.TYPES;
    };

    /**
     * checkIfAllFilesAreInTheSameType - check if all the file in the same type (video or image)
     * @param folderType - video or image
     */
    const checkIfAllFilesAreInTheSameType = (folderType) => folderType && uiFileList.every((file:any) => typeof folderType[file.type] === 'string');

    /**
     * sendToS3 - send a parallel request to s3 in chunks
     * @param filesChunks - matrix of files split to 50 items in each row
     * @param i - index in chunk array
     */
    const sendToS3 = async (filesChunks, i = 0) => {
        if (i === filesChunks.length) {
            return;
        }

        const promisesS3:any = [];
        const promisesS3Response:any = [];


        filesChunks[i].forEach((file:any) => file.status === IMAGE_STATUS.UPLOADING && promisesS3.push(openSignUl(file)));
        const s3Reqs:any = await Promise.all(promisesS3);

        s3Reqs.forEach((promiseS3) => {
            promiseS3.file.status === IMAGE_STATUS.UPLOADING && promiseS3.req && promisesS3Response.push(sendFileToS3(promiseS3.req, promiseS3.file));
        });
        await Promise.all(promisesS3Response);

        return sendToS3(filesChunks, i + 1);
    };

    /**
     * fileBoilerPlate - change file to object like here
     * @param file - file from computer or server
     * @param index - index of file
     */
    const fileBoilerPlate = (file, index) => {

        const splitFilesName = file.name.split('.');
        const type = splitFilesName[splitFilesName.length - 1];
        const sizeMb = file.size / (1024 * 1024);
        const fileObj:any = {
            name: file.name,
            title: `${file.name} ${utilService.formatSize(sizeMb)}`,
            status: IMAGE_STATUS.UPLOADING,
            type,
            errorMsg: '',
            fileData: file,
            size: sizeMb,
            client_id: index
        };


        if ('url' in file) {
            fileObj.url = file.url;
        }

        if ('file_id' in file) {
            fileObj.serverId = file.file_id;
        }


        return fileObj;
    };

    /**
     * setUiFileListFromOutSide - set UiFileList From OutSide
     * @param uiFileListFromOutSide - uiFileList
     */
    const setUiFileListFromOutSide = (uiFileListFromOutSide) => {
        uiFileListFromOutSide.forEach((file) => {
            filesStatusList[file.serverId] = {status: IMAGE_STATUS.SUCCESS};

        });
        counterOfFiles.numberOfFiles = uiFileListFromOutSide.length;
        counterOfFiles.counter = uiFileListFromOutSide.length;
        setIsProcessStarted(true);
        setUiFileList(uiFileListFromOutSide);
    };

    /**
     * _normalizedFiles - organized array in readable way
     * @param files - files list
     */
    const _normalizedFiles = (files) => {
        const normalizedFiles:any = [];
        const copyUiFileList = JSON.parse(JSON.stringify(uiFileList));
        const allNames = {};
        let index = copyUiFileList.length > 0 ? copyUiFileList.length : 0;

        copyUiFileList.forEach((file) => 'name' in file && (allNames[file.name] = file.name));
        setIsProcessStarted(false);

        files.forEach((file) => {
            if ('name' in file && !(file.name in allNames)) {
                normalizedFiles.push(fileBoilerPlate(file, index));
                allNames[file.name] = file.name;
                index++;
            }

        });

        copyUiFileList.push(...normalizedFiles);


        setUiFileList(copyUiFileList);
    };

    /**
     * when uiFileList change activte upload process
     */
    useEffect(() => {
        uiFileList.length > 0 && !isProcessStarted && setFilesAfterFileUpdate();
    }, [uiFileList.length]);

    useEffect(() => {
        PROJECT_ID.projectId = projectIdArg;
    }, []);

    /**
     * setWongFiles - if files are wong from verifyFiles API
     * @param res - verifyFiles API response
     */
    const setWongFiles = (res) => {
        if (res.data) {
            const {FileExist, TooLarge, WrongFileType} = res.data;
            const wongArray = [FileExist, TooLarge, WrongFileType];
            const hashFailedKey = {
                0: 'EXIST',
                1: 'SIZE',
                2: 'TYPE'
            };

            wongArray.forEach((obj, i) => {
                for (const key in obj) {
                    if (has(obj, key)) {
                        setStatus(IMAGE_STATUS.FAILED, uiFileList[obj[key].id], IMAGE_STATUS.VERIFY_FAILED, hashFailedKey[i]);
                    }
                }
            });
        }
    };

    const startProcess = async (getSignUrlResArr) => {
        if (getSignUrlResArr.length > 0) {
            try {
                const getSignUrlRes:any = await getSignUrl(getSignUrlResArr);
                const copyUiFileList = [...uiFileList];

                copyUiFileList.forEach((f) => {
                    const fileServerData = getSignUrlRes.data[f.name];

                    if (fileServerData) {
                        f.serverId = fileServerData.id;
                        f.url = fileServerData.url;
                        filesStatusList[fileServerData.id] = {status: IMAGE_STATUS.UPLOADING};
                    }

                });

                setUiFileList(copyUiFileList);
                sendToS3(utilService.splitArrayToChunks(copyUiFileList, 10));
            } catch (e) {
                uiFileList.forEach((file) => setStatus(IMAGE_STATUS.FAILED, file, IMAGE_STATUS.VERIFY_FAILED, 'UPLOAD'));
            }
        }

    };

    /**
     * setFiles - the full process that send the files to s3
     */
    const setFilesAfterFileUpdate = async () => {
        const folderType = findTypeFolder();
        const notAllowedFilesType:any = checkIfAllFilesAreInRightType(folderType);

        setIsProcessStarted(true);
        // eslint-disable-next-line no-nested-ternary
        FOLDER_TYPE.type = isAutoClassification ? 'referenceimage' : 'mp4' in folderType ? 'video' : 'image';
        counterOfFiles.numberOfFiles = uiFileList.length;
        // @ts-ignore
        openModal && openModal();

        const res = await verifyFiles();

        setWongFiles(res);
        const isFolderTypeIsOk = folderTypeBeforeUpload === 'empty' ? false : folderTypeBeforeUpload !== FOLDER_TYPE.type;

        if (notAllowedFilesType.length > 0 || isFolderTypeIsOk || !checkIfAllFilesAreInTheSameType(folderType)) {
            setIsFailedFiles(true);
        } else {
            startProcess(uiFileList.filter((file) => file.status !== IMAGE_STATUS.FAILED && file.status !== IMAGE_STATUS.DONE));
        }
    };

    /**
     * setFiles - the full process that send the files to s3
     * @param files - files list
     */
    const setFiles = (files) => _normalizedFiles(files);

    return {
        setFiles,
        isFailedFiles,
        projectIdUploadProcess: PROJECT_ID.projectId,
        closeModal,
        processIsDone,
        onDoneProcess,
        uploadCounter: counterOfFiles.counter,
        onDeleteFile,
        uiFileList: uiFileList.filter((file) => !fileDeleted[file.serverId]),
        uiFiledFileList: uiFileList.filter((file) => fileDeleted[file.serverId] || file.status === IMAGE_STATUS.VERIFY_FAILED),
        retryFile,
        numberOfFiles: counterOfFiles.numberOfFiles,
        initProjectId,
        retryAllFiledFiles,
        fileBoilerPlate,
        setUiFileListFromOutSide,
        setUiFileList
    };
};

export default useUploadProcess;
